// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QIQUv","active":"styles_active__J_Y5i"};